import { instance } from "../axios";

export const searchCenterPeople = async (centerId, personType, email) => {
  const response = await instance.get(
    `/center/${centerId}/people/${personType}/candidates`,
    { params: { email } },
  );

  return response.data;
};

export const addCenterPerson = async (centerId, personType, userId) => {
  const response = await instance.post(
    `/center/${centerId}/people/${personType}`,
    { userId },
  );

  return response.data;
};

export const removeCenterPerson = async (centerId, personType, userId) => {
  const response = await instance.delete(
    `/center/${centerId}/people/${personType}/${userId}`,
  );

  return response.data;
};
